import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import { handleSubmitInquiry } from './actions';
import { ISubmitInquiryState } from './slice.interface';

const initialState: ISubmitInquiryState = {
  isLoading: false,
};

export const createInquirySlice = createSlice({
  name: 'create-inquiry',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleSubmitInquiry.pending, (state: ISubmitInquiryState) => {
        state.isLoading = true;
      })
      .addCase(handleSubmitInquiry.rejected, (state: ISubmitInquiryState) => {
        state.isLoading = false;
      })
      .addCase(handleSubmitInquiry.fulfilled, (state: ISubmitInquiryState) => {
        state.isLoading = false;
        eventBus.emit(EventType.INQUIRY_SUBMIT_SUCCESS);
      });
  },
});

export default createInquirySlice.reducer;
